import { useBusinessEngineApi } from 'infrastructure/api';
import { HTTP } from 'framework/api';
import { useMessageService, ErrorMessage } from 'framework/ui/Message';

const useOneClickService = () => {
  const { addMessage } = useMessageService();
  const handleError = (error: any) => {
    switch (error.status) {
      case HTTP.UNAUTHORIZED:
        addMessage(new ErrorMessage('The password is incorrect'));
        break;
      default:
        throw error;
    }
  };

  const { sendPostRequest } = useBusinessEngineApi();

  const getUsers = async (oneClickPassword: any) => {
    try {
      const response = await sendPostRequest('/authentication/users', oneClickPassword);
      return response.json();
    } catch (error) {
      handleError(error);
      throw error;
    }
  };

  const getAccessTokenForUser = async (username: any, oneClickPassword: any) => {
    try {
      const response = await sendPostRequest(`/authentication/users/${username}`, oneClickPassword);
      return response.json();
    } catch (error) {
      handleError(error);
      throw error;
    }
  };

  return {
    getUsers,
    getAccessTokenForUser,
  };
};

export default useOneClickService;
